<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="px-3 board-header">
      <div v-if="!selectedBranch || selectedBranch == 0">
        <div class="text-center mt-5">
          <p>
            <font-awesome-icon
              :icon="['fas', 'project-diagram']"
              style="margin-right: 20px; font-size: 35px;"
            />
          </p>
          <h5>
            {{ this.$t('reports.groupNps.reportTitle') }}
          </h5>
          <p>
            {{ this.$t('reports.groupNps.selIh1Label') }}
          </p>
        </div>
      </div>
      <div v-else class="row mt-4">
        <div class="row col-12">
          <div class="col-4" style="padding: 0px 10px;">
            <div class="col-12 board-border" style="display: flex;">
              <div style="min-width: 70%;">
                <nps-bar-values
                  :selectedBranch="selectedBranch"
                  :graphTitle="selectedBranchName"
                  :graphType="'branch'"
                />
              </div>
            </div>
          </div>
          <div class="col-4" style="padding: 0px 10px;">
            <div class="col-12 board-border" style="display: flex;">
              <div style="min-width: 70%;">
                <nps-bar-values
                  :selectedGroup="selectedGroup"
                  :graphTitle="selectedGroup"
                  :graphType="'group'"
                />
              </div>
            </div>
          </div>
          <div class="col-4" style="padding: 0px 10px;">
            <div class="col-12 board-border" style="display: flex;">
              <div style="min-width: 70%;">
                <nps-bar-values
                  :allBranches="allBranches"
                  :graphTitle="generalTitle"
                  :graphType="'all'"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row col-12 mt-4">
          <div class="col-12" style="padding: 0px 10px;">
            <div class="col-12 board-border">
              <reviews-group
                :showCollapsed="false"
                :selectedBranch="selectedBranch"
                :selectedGroup="selectedGroup"
              />
            </div>
          </div>
        </div>
        <div class="row col-12 mt-4">
          <div class="col-12" style="padding: 0px 10px;">
            <div class="col-12 board-border">
              <like-dislike-group
                :showCollapsed="false"
                :selectedBranch="selectedBranch"
                :selectedGroup="selectedGroup"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import dashboardBar from '@/components/molecules/dashboard-bar';
import npsBarValues from '@/components/molecules/nps-bar-values';
import loader from '@/components/atoms/loader';
import reviewsGroup from '@/components/molecules/highcharts/reports/rankings/components/reviews-group';
import likeDislikeGroup from '@/components/molecules/highcharts/reports/rankings/components//like-dislike-group';
import EventBus from '../../../../eventBus';

export default {
  name: 'GroupNps',
  components: {
    npsBarValues,
    dashboardBar,
    loader,
    reviewsGroup,
    likeDislikeGroup,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    selectedBranch: null,
    selectedGroup: null,
    allBranches: true,
    needToSelectIh1: false,
    options: [],
    generalTitle: '',
    selectedBranchName: null,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapFields('branches', ['ih1']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getDashboardData();
    },

    myActionId: function watchmyActionId() {
      this.getDashboardData();
    },

     myActionsIds: function watchmyActionsIds() {
      this.getDashboardData();
    },

    calendarDates: function watchCalendarDates() {
      this.getDashboardData();
    },

    myIh1: function watchMyIh1() {
      this.getDashboardData();
    },

    myIh2: function watchMyIh2() {
      this.getDashboardData();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getDashboardData();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getDashboardData();
    },

    myMetric: function watchMyMetric() {
      this.getDashboardData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getDashboardData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getDashboardData();
    },
  },

  methods: {
    ...mapActions('branches', ['listBranchesIh1']),
    async getDashboardData() {
      this.loading = true;
      if (this.userAuth.ih1) {
        this.needToSelectIh1 = (this.userAuth.ih1.length !== 1);
      } else {
        this.needToSelectIh1 = true;
      }
      this.selectedBranch = this.myIh1;
      if (this.selectedBranch !== 0) {
        await this.getSelectedGroupAndBranchName();
      }
      this.loading = false;
    },
    formatToPrice(value) {
      return value.toFixed(0);
    },
    async getSelectedGroupAndBranchName() {
      for (let j = 0; j < this.ih1.listFilters.length; j++) {
        if (this.selectedBranch === this.ih1.listFilters[j]._id.toString()) {
          this.selectedGroup = this.ih1.listFilters[j].group;
          this.selectedBranchName = this.ih1.listFilters[j].corporate_name;
          break;
        }
      }
    },
    async changedBranch() {
      await this.getSelectedGroupAndBranchName();
      this.getDashboardData();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.generalTitle = this.$t('reports.groupNps.generalTitleLabel');
  },

  async mounted() {
    this.loading = true;
    await this.getDashboardData();
    this.loading = false;
  },

  beforeDestroy() {
    EventBus.$off('switch-chart');
    EventBus.$off('data-source');
    EventBus.$off('accumulated-report');
  },
};
</script>

<style lang="scss">
#number-nps {
  font-size: 50px !important;
}
</style>
<style lang="scss" scoped>
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.board-box {
  width: 10%;
  text-align: left;
  font-size: 16px;
  margin: 0px 20px;
  border: 1px solid #eee;
}
.board-box-value {
  float: right;
  padding-right: 40%;
  font-size: 24px;
}
.nps-display {
  border: none !important;
}
.board-percentil {
  padding: 20px 0px 20px 20px;
  min-width: 150px;
}
.board-percentil-label {
  font-size: 14px;
}
.board-percentil-percent {
  font-size: 20px;
}
.board-percentil-value {
  font-size: 16px;
}
.board-border {
  border: 1px solid #eee;
}
.board-header h1 {
  font-size: 16px;
}
.summary {
  display: flex;
  flex-direction: row;

  h1 {
    font-size: 16px;
  }

  .summary-channel {
    display: contents;
    flex-direction: column;
    padding: 5px;

    .container {
      border: 0;
      padding: 0;
      display: flex;
      flex-direction: row;

      .item {
        display: flex;
        flex-direction: column;
        padding: 5px 8px;
        margin-right: 10px;
        min-height: 79px;
        max-height: 79px;
        min-width: 200px;
        max-width: 200px;
        -webkit-box-shadow: 0px 0px 9px -6px #000000;
        box-shadow: 0px 0px 9px -6px #000000;
        transition: 0.3s;

        &:hover {
          -webkit-box-shadow: 0px 0px 12px -6px #000000;
          box-shadow: 0px 0px 12px -6px #000000;
        }

        header {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-transform: uppercase;

          h2 {
            font-size: 11px;
          }
        }

        .description {
          display: flex;
          flex-direction: column;
          flex: 1;
          justify-content: center;
          align-items: center;

          span {
            font-size: 22px;
            font-weight: lighter;

            & + span {
              margin-top: -3px;
              font-size: 12px;
            }
          }
        }

        &:last-of-type {
          margin-right: 30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/group-nps/index.vue